import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Choice } from '../../model/choice';


@Component({

    selector: 'create-choice-dialog',
    styles: [
        `
            .modal-header{
                border-top-right-radius: 10px;
                border-top-left-radius: 10px;
                background-color:dodgerblue;
                color:antiquewhite;
            }
            .modal-content{
                border-top-right-radius: 18px;
                border-top-left-radius: 18px;
            }
            .closeX{color:azure;size:25px;}
            .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
            .btn-danger:hover{background-color: #FF2400;}
            .appWindow{height:25px;margin-right:140px;}
            .genericIcon{height:90px;}
    .modal-dialog {
        width: 50%;
        margin:  auto;
    }
    .borderGray{
        border: 1px solid #ccc;
    }
    .borderRed{
        border: 1px solid red;
    }
    .label{width:100%;}
        `
    ],
    template: `
        <div class="modal" [style.display]="hide ? 'none' : 'inline'" style="margin : 20px; ">
    <div class="modal-dialog" *ngIf="choice != null">
        <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <h4 class="modal-title"><span><img alt="headerIcon" class="appWindow" src="../../../assets/images/168.png"></span>Add Choice</h4>
                <button type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close" (click)="toggleChoiceComponent()">
                    <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
                </button>
            </div>
            <div class="modal-body">
                        <!-- Texts -->

              <div class="row" style="margin-top:20px;">
                <div class="col-md-12">
                  <label>Available Choices </label>
                </div>
                <div style="border-color: #1f6abb;border-style: dashed;border-width: thin;width:100%;margin-left:10px;margin-right:10px;">
                      <ng-container *ngFor="let opt of this.choiceArr">
                          <h3 *ngIf="opt.texts.get(selectedLanguage)!=null" style="margin-left: 15px;width:fit-content;float: left"><span class="badge badge-primary">{{opt.texts.get(selectedLanguage)}}<span style="margin-left: 10px; color:red;" class="pull-right hand"  (click)="removeChoice(opt)"><i style="font-size: 18px;" class="fas fa-times"></i></span></span></h3>
                      </ng-container>
                </div>
                <div class="col-md-12" style="margin-top: 20px;">
                  <table>
                    <tr><td><input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" name="textsChoice" placeholder="Text Choice..."  [(ngModel)]="choiceString"></td><td></td></tr>
                  </table>
                </div>

                <div class="col-md-12" style="margin-top: 20px;">
                    <p class="label">Update an existing choice for the selected language:</p>

                    <div class="btn-group dropdown">
                        <button type="button" class="btn btn-primary">{{getChoiceNoToUpdate()}}</button>
                        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu">
                            <ng-container *ngFor="let opt of this.choiceArr">
                                <a class="dropdown-item"  title="{{opt.texts.get(selectedLanguage)}}" (click)="setChoiceToUpdate(opt.no)">{{opt.no}}</a>
                            </ng-container>
                        </div>
                    </div>
                    <!--<div class="dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Choice No To Update
                        </button>
                        <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
                            <li *ngFor="let opt of this.choiceArr">
                                <a class="dropdown-item"  title="{{opt.texts.get(selectedLanguage)}}" (click)="setChoiceToUpdate(opt.no)">{{opt.no}}</a>
                            </li>
                        </ul>
                    </div>-->
                </div>
              </div>
            </div>
            <!-- footer-->
            <div class="modal-footer ">
                <button type="button" (click)="newChoice()" class="btn btn-outline-success clickable hand" id="submit"><span class="glyphicon glyphicon-floppy-disk" ></span> {{'addChoice'|translate}}</button>
            </div>
        </div>
    </div>
</div>
     `
})
export class CreateChoiceComponent {

    // @Input() languages: string[];
    @Input() selectedLanguage:string;
    private choiceArr:Choice[];
    private choice: Choice;
    private hide = true;
    private choiceString:string;
    private choiceNoToUpdate=-1;
    @Output() NewChoice: EventEmitter<Choice> = new EventEmitter();
    @Output() CancelChoice: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    public toggleChoiceComponent() {
        this.hide = !this.hide;
    }

    private hideDialog() {
        this.CancelChoice.emit();
    }

    private newChoice() {

        this.addChoiceToArray();
        // this.updateChoice();
        console.log('new choice...:-> '+ JSON.stringify(this.choice));
        this.NewChoice.emit(this.choice);
    }

    public toggleModal() {
      this.choice = new Choice();
      this.hide = !this.hide;
    }

  /*private updateChoice() {
      if(this.choice.texts.has(this.selectedLanguage)) {
        const arr = this.choice.texts.get(this.selectedLanguage);
        arr.push(val);
        this.choice.texts.set(this.selectedLanguage,arr);
      } else {
        const arr = [];
        arr.push(val);
        this.choice.texts.set(this.selectedLanguage,arr);
      }
    this.choice.texts.set(this.selectedLanguage,this.choiceArr);
    console.log(this.choice.texts);
  }*/

  private addChoiceToArray():void {

      if(this.choiceArr == null) {
        this.choiceArr = [];
      }
      // tslint:disable-next-line:triple-equals
      if(this.choiceNoToUpdate!=-1) {   // this.choice.texts.has(this.selectedLanguage
          const arr = [];
          arr.push(this.choiceString);
          // this.choice.texts.set(this.selectedLanguage,arr);
          this.choiceArr[this.choiceNoToUpdate-1].texts.set(this.selectedLanguage,arr);
      } else {
          this.choice.no = this.choiceArr.length+1;
          const arr = [];
          arr.push(this.choiceString);
          this.choice.texts.set(this.selectedLanguage, arr);
          this.choiceArr.push(this.choice);
      }
    /**/
  }

  private removeChoice(opt: Choice):void {
    this.choiceArr.splice(this.choiceArr.indexOf(opt),1);
  }

  public setChoiceArr(choiceArr:Choice[]):void {

    this.choiceArr = choiceArr;console.log(this.choiceArr);
  }

  private setChoiceToUpdate(no: number) {
        this.choiceNoToUpdate = no;
  }

  private getChoiceNoToUpdate() {
        return this.choiceNoToUpdate===-1?'Choice No to Update':this.choiceNoToUpdate;
    }
}
